import { useEffect } from "react";
import { useAuth } from "@hole/shared/auth";
import { useNavigate } from "react-router-dom";

/**
 * Login page - Redirects to Auth0 Universal Login
 *
 * Uses Auth0's hosted Universal Login page for authentication.
 * This is the recommended approach - secure, maintained by Auth0,
 * and supports all authentication methods (password, social, MFA, passkeys).
 */
export default function Login() {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      // Already logged in, go to homepage
      navigate("/");
    } else if (!isLoading) {
      // Not logged in, redirect to Auth0 Universal Login
      loginWithRedirect({
        appState: {
          returnTo: "/foia-generator", // Go to FOIA generator after login
        },
      });
    }
  }, [isAuthenticated, isLoading, loginWithRedirect, navigate]);

  // Show loading state while checking auth or redirecting
  return (
    <div className="min-h-screen w-full bg-brand-martinique flex items-center justify-center">
      <div className="text-center">
        <div className="text-white font-agency text-2xl mb-4">
          Redirecting to login...
        </div>
        <div className="text-brand-gray font-muller text-sm">
          You'll be redirected to our secure login page
        </div>
      </div>
    </div>
  );
}
